module.exports = __webpack_public_path__ + "static/media/29DUNON13.807a11d5.jpg";